import Vue from 'vue';
import Component from 'vue-class-component';
import * as utils from 'core/utils';
import * as i18next from 'i18next';
import { G2S } from 'core/g2s';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class HomeComponent extends Vue {
    location: any = location;
    gaClientId: string = '';

    mounted() {
        utils.PixelsService.setPixelForHomepage(document.getElementById('pixels')!);
        setTimeout(() => this.gaClientId = (<any>window).__gaClientID, 1500);

        (<any>this.$root).$refs.dialogApp.show();
    }

    get newYearDate() {
        return new Date() >= new Date(new Date().getFullYear(), 11, 21) || new Date() <= new Date(new Date().getFullYear(), 0, 11);
    }

    get currentSite() {
        return G2S.config.markets.find((market) => market.code === G2S.config.marketCode);
    }

    getCurrencySymbol(code) {
        return utils.String.currencySymbol(code);
    }

    onChangeMarket(subdomain) {
        (<any>this).$ga.sendEvent('global.header', `market.change.${G2S.config.marketCode}_${subdomain}`, `global.header.market.change.${G2S.config.marketCode}_${subdomain}`);
    }

    onFaqClick() {
        (<any>this).$ga.sendEvent('global.header', 'market.change.en_ru', 'global.header.market.change.en_ru');

        window.location.href = '/faq';
    }

    onSupportClick() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.footer');
    }
}
